import React from 'react'
import {Auth} from 'aws-amplify';
import axios from "axios";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Button} from "primereact/button";
import {Dialog} from "primereact/dialog";
import {InputText} from "primereact/inputtext";
import {Messages} from "primereact/messages";
import {Dropdown} from 'primereact/dropdown';
import {Toolbar} from "primereact/toolbar";


class UpdateAbschlagtabelle extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            isFileUploaded: false,
            dataTableUploadInProgress: false,
            dataTableUploadProgress: 0.0,
            entries: [],
            selectedEntry: null,
            displayDialog: false,
            isLoading: false,
            carType: null,
            versions: []
        };

        this.carTypes = [
            {label: 'nfz'},
            {label: 'kfz'}
        ];

        this.onEntrySelect = this.onEntrySelect.bind(this);
        this.onTypeChange = this.onTypeChange.bind(this);

        this.leftToolbarTemplate = this.leftToolbarTemplate.bind(this);
    }

    componentDidMount() {
        //get the current values
        Auth.currentSession()
            .then(session => {
                const axiosConfig = {
                    headers: {'Authorization': session.getIdToken().getJwtToken()}
                };
                axios.get(process.env.REACT_APP_IUCB_ABSCHLAG_ENDPOINT, axiosConfig)
                    .then(result => {
                        if(result.data && result.data.length > 0) {
                            this.setState({entries: result.data});
                        }
                    })
                    .catch (err => {
                        console.log(err);
                    });
                axios.get(process.env.REACT_APP_IUCB_ABSCHLAG_VERSIONS_ENDPOINT, axiosConfig)
                    .then(result => {
                        this.setState({versions: result.data});
                    })
                    .catch (err => {
                        console.log(err);
                    });
            })
            .catch (err => {
                console.log(err);
            });
    }

    onEntrySelect(e){
        this.newEntry = false;
        this.setState({
            displayDialog:true,
            entry: Object.assign({}, e.data)
        });
    }

    addNew = () => {
        this.newEntry = true;
        this.setState({
            entry: {mbv_ohne_ausstattung:'', startwertkurve: '', abschlag: '', wert_derivat: '', fahrzeug_typ: ''},
            displayDialog: true
        });
    };

    save = () => {
        let meldungen = this.state.entries;
        if(this.newEntry)
            meldungen.push(this.state.entry);
        else
            meldungen[this.findSelectedCarIndex()] = this.state.entry;

        this.setState({entries:meldungen, selectedEntry:null, entry: null, displayDialog:false});
    };

    findSelectedCarIndex() {
        return this.state.entries.indexOf(this.state.selectedEntry);
    }

    updateProperty(property, value) {
        let entry = this.state.entry;
        entry[property] = value;
        this.setState({entry: entry});
    }

    delete() {
        let index = this.findSelectedCarIndex();
        this.setState({
            entries: this.state.entries.filter((val, i) => i !== index),
            selectedEntry: null,
            entry: null,
            displayDialog: false});
    }

    updateValues = () => {
        //update values by JSON
        Auth.currentSession()
            .then(session => {
                const axiosConfig = {
                    headers: {'Authorization': session.getIdToken().getJwtToken()}
                };

                const data = {
                    updated_values: this.state.entries
                };
                this.setState({isLoading: true});
                axios.post(process.env.REACT_APP_IUCB_ABSCHLAG_ENDPOINT, data, axiosConfig)
                    .then(result => {
                        this.messages.show({severity: 'success', summary: 'Success', detail: 'Values updated.'});
                        this.setState({isLoading: false});
                    })
                    .catch (err => {
                        this.messages.show({severity: 'error', summary: 'Upload Error', detail: err.message});
                        this.setState({isLoading: false});
                    })
            })
            .catch (err => {
                console.log(err);
            });

    };

    onFileChange = (files) => {
        const selectedFile = files[0];
        if (!selectedFile) {
            return;
        }
        //upload to endpoint
        Auth.currentSession()
            .then(session => {
                const axiosConfig = {
                    headers: {'Authorization': session.getIdToken().getJwtToken()}
                };
                const params = {
                    file_identifier: 'abschlag_tabelle'
                };

                //retrive pre-signed URL
                axios.post(process.env.REACT_APP_IUCB_UPLOAD_ENDPOINT, params, axiosConfig)
                    .then(result => {
                        const url = result.data.upload_url;
                        // after recieving the signed URL an upload via put is possible
                        const axiosUploadConfig = {
                            headers: {'content-disposition': 'Attachment', 'Content-Type': selectedFile.type},
                            onUploadProgress: (progressEvent) => {
                                const totalLength = progressEvent.lengthComputable ? progressEvent.total : progressEvent.target.getResponseHeader('content-length') || progressEvent.target.getResponseHeader('x-decompressed-content-length');
                                if (totalLength !== null) {
                                    this.setState({dataTableUploadProgress: Math.round((progressEvent.loaded * 100) / totalLength)});
                                }
                            }
                        };
                        axios.put(url, selectedFile, axiosUploadConfig)
                            .then(result => {
                                this.messages.show({severity: 'success', summary: 'Success', detail: 'File is completely uploaded!'});

                                this.setState({
                                    dataTableUploadInProgress: false,
                                    dataTableUploadProgress: 0.0,
                                    isFileUploaded: true
                                });
                            })
                            .catch(err => {
                                this.setState({
                                    dataTableUploadInProgress: false,
                                    dataTableUploadProgress: 0.0
                                });
                                this.messages.show({severity: 'error', summary: 'Upload Error', detail: err.message});
                            });
                    })
                    .catch(err => {
                        console.log(err);
                    })
            })
            .catch (err => {
                console.log(err);
            });
    };

    leftToolbarTemplate() {
        return (
            <React.Fragment>
                <Button type="button" className="p-mr-2 p-d-inline-block" label="Add" icon="pi pi-plus" onClick={() => this.addNew()}/>
            </React.Fragment>
        )
    }

    onTypeChange(event) {
        this.dt.filter(event.value, 'fahrzeug_typ', 'equals');
        this.setState({carType: event.value});
    }

    render () {
        let dialogFooter = <div className="ui-dialog-buttonpane p-clearfix">
            <Button label="Delete" icon="pi pi-times" onClick={() => this.delete()}/>
            <Button label="Save" icon="pi pi-check" onClick={() => this.save()}/>
        </div>;

        const types = [
            {label: 'All Types', value: null},
            {label: 'nfz', value: 'nfz'},
            {label: 'kfz', value: 'kfz'}
        ];

        let typeFilter = <Dropdown style={{width: '100%'}}
                                    value={this.state.carType} options={types} onChange={this.onTypeChange}/>;

        return (
            <main className="o-page-wrap">
                <div>
                    <h1>SWK-Derivat</h1>
                    <p>Please use the table or the file upload function to update the values. If you provide a CSV file, please refresh the page to see the changes.</p>
                    <h2>Current Values</h2>

                    <DataTable value={this.state.entries} style={{width: '100%'}} scrollable={true}
                               ref={(el) => this.dt = el}
                               paginator={true}
                               selectionMode="single" selection={this.state.selectedEntry}
                               onSelectionChange={e => this.setState({selectedEntry: e.value})}
                               onRowSelect={this.onEntrySelect}
                               rows={20} rowsPerPageOptions={[20,50,100]}>
                        <Column field="mbv_ohne_ausstattung" header="MBV" style={{width:'100px'}} sortable={true} filter={true}/>
                        <Column field="startwertkurve" header="Curve ID (SWK)" style={{width:'100px'}} sortable={true} filter={true} />
                        <Column field="abschlag" header="Discount" style={{width:'100px'}} />
                        <Column field="wert_derivat" header="Value Derivat" style={{width:'100px'}} />
                        <Column field="fahrzeug_typ" header="Car Type" style={{width:'100px'}} sortable={true} filter={true} filterElement={typeFilter} />
                    </DataTable>

                    <Toolbar className="p-mb-4" left={this.leftToolbarTemplate} ></Toolbar>

                    <br />
                    <button type="button" className="c-btn" onClick={ () => this.updateValues() }
                            disabled={this.state.isLoading}>
                        <span className="c-btn__text">Save and Update</span>
                        {this.state.isLoading ?
                            <div className="c-spinner c-spinner--small">
                                <svg>
                                    <circle className="c-spinner__indicator" cx="9" cy="9" r="8" fill="none"/>
                                </svg>
                            </div>
                            : null
                        }
                    </button>

                    <Messages ref={(el) => this.messages = el}></Messages>

                    <Dialog visible={this.state.displayDialog} style={{ width: '70vw' }} header="Entry Details" modal={true} footer={dialogFooter} onHide={() => this.setState({displayDialog: false})}>
                        {
                            this.state.entry &&

                            <div className="p-grid p-fluid">
                                <div className="p-col-2"><label htmlFor="mbv_ohne_ausstattung">MBV</label></div>
                                <div className="p-col-4">
                                    <InputText id="mbv_ohne_ausstattung" onChange={(e) => {this.updateProperty('mbv_ohne_ausstattung', e.target.value)}} value={this.state.entry.mbv_ohne_ausstattung}/>
                                </div>

                                <div className="p-col-2"><label htmlFor="fahrzeug_typ">Car Type</label></div>
                                <div className="p-col-4">
                                    <Dropdown value={this.state.entry.fahrzeug_typ} options={types}
                                              onChange={(e) => {this.updateProperty('fahrzeug_typ', e.target.value)}}
                                              placeholder="Select a Curve"/>
                                </div>

                                <div className="p-col-2"><label htmlFor="startwertkurve">Curve ID (SWK)</label></div>
                                <div className="p-col-4">
                                    <InputText id="startwertkurve" onChange={(e) => {this.updateProperty('startwertkurve', e.target.value)}} value={this.state.entry.startwertkurve}/>
                                </div>

                                <div className="p-col-2"><label htmlFor="abschlag">Discount</label></div>
                                <div className="p-col-4">
                                    <InputText id="abschlag" onChange={(e) => {this.updateProperty('abschlag', e.target.value)}} value={this.state.entry.abschlag}/>
                                </div>

                                <div className="p-col-2"><label htmlFor="wert_derivat">Value Derivat</label></div>
                                <div className="p-col-4">
                                    <InputText id="wert_derivat" onChange={(e) => {this.updateProperty('wert_derivat', e.target.value)}} value={this.state.entry.wert_derivat}/>
                                </div>
                            </div>
                        }
                    </Dialog>


                    <h2>Upload Values as CSV</h2>
                    <p>Please upload a CSV file with the same structure as the table above.</p>
                    <label htmlFor="file-upload" className="c-upload"
                           data-mouseover-text="This is the mouseover variant of the upload container">
                        <input className="c-upload__input" type="file" id="file-upload" onChange={ (e) => this.onFileChange(e.target.files) } />

                        <p className="c-upload__description">
                            <span>Click on this container for file uploads</span>
                            <span>or</span>
                        </p>

                        <div className="c-upload__actions">
                            <label className="c-upload__button  c-btn" htmlFor="file-upload">
                                <span>click here</span>
                            </label>
                        </div>
                    </label>

                    <h2>Versions</h2>
                    <DataTable value={this.state.versions} style={{width: '100%'}}
                               paginator={true}
                               rows={20} rowsPerPageOptions={[20,50,100]}>
                        <Column field="filename" header="Filename" style={{width:'100px'}} />
                        <Column field="version_id" header="Version ID" style={{width:'100px'}} />
                        <Column field="content_length" header="File Size (Bytes)" style={{width:'100px'}} />
                        <Column field="last_modified" header="Last Modified" style={{width:'100px'}} />
                    </DataTable>
                </div>
            </main>
        )
    }
}
export default UpdateAbschlagtabelle;
